<myabvv-menu></myabvv-menu>
<myabvv-spinner-overlay></myabvv-spinner-overlay>

<div class="l-shell">
  @if (showChrome() && !layout.useMobileChrome()) {
    <myabvv-sidebar-nav></myabvv-sidebar-nav>
  }
  <main class="l-shell__content">
    <myabvv-member-banner></myabvv-member-banner>
    <router-outlet></router-outlet>
  </main>
</div>

@if (showChrome() && layout.useMobileChrome()) {
  <myabvv-bottom-bar></myabvv-bottom-bar>
}

<myabvv-footer></myabvv-footer>

@if (showTokenExpiryDialog) {
  <myabvv-token-expiry-dialog></myabvv-token-expiry-dialog>
}
